module.exports = __webpack_public_path__ + "0e38345a059b458b4f7a913ff1f0ace3.pdf";